import * as Sentry from '@sentry/browser';
import config from 'config';

export function init() {
  if(config.sentry.url) {
    Sentry.init({ dsn: config.sentry.url });
  }
}